import "./Layout.scss";
import { email, location, phone } from "../constants/appConstats";
import { PhoneLogo } from "../assets/svg/PhoneLogo";
import { EmailSvg } from "../assets/svg/EmailSvg";
import { LocationSvg } from "../assets/svg/LocationSvg";
import {
  contactUsLabel,
  footerDescriptionLabel,
} from "../constants/translations";
import { Logo } from "../assets/photos";
import { TikTokSvg, InstagramColorsSvg, WhatsAppColorSvg } from "../assets/svg";
import {
  openFooterEmail,
  openFooterWhatsApp,
  openInstagram,
  openLocationInMaps,
  openTikTok,
} from "../helpers/Helper";

export const Footer = ({ languageId }) => {
  return (
    <footer className="app-footer">
      <div className="column1">
        <div className="logo">
          <img width={"100%"} height={"100%"} src={Logo} alt="Logo" />
        </div>
        <div className="description">
          {footerDescriptionLabel[languageId]?.label}
        </div>
        <div className="links">
          <div className="logoItem" onClick={() => openTikTok()}>
            <TikTokSvg width={42} height={42} />
          </div>
          <div className="logoItem" onClick={() => openInstagram()}>
            <InstagramColorsSvg width={40} height={40} />
          </div>
          <div
            className="logoItem"
            onClick={() => openFooterWhatsApp(languageId)}
          >
            <WhatsAppColorSvg width={42} height={42} />
          </div>
        </div>
      </div>

      <div className="column2">
        <div className="title">{contactUsLabel[languageId]?.label}</div>
        <div className="item" onClick={() => openFooterWhatsApp(languageId)}>
          <PhoneLogo width={24} height={24} /> <span>{phone}</span>
        </div>
        <div className="item" onClick={() => openFooterEmail({ languageId })}>
          <EmailSvg width={24} height={24} />
          <span>{email}</span>
        </div>
        <div className="item" onClick={() => openLocationInMaps()}>
          <LocationSvg width={24} height={24} /> <span>{location}</span>
        </div>
      </div>
    </footer>
  );
};
